<template>
    <ubi-page-container>
        <template v-slot:page-actions>
            <el-button class="inline" @click="exporter">
                <span @click="eventAnalytics('total_contacts')">{{ $t("contacts.exportResults") }}</span>
            </el-button>
        </template>
        <div v-loading="loading"
             :element-loading-text="$t('portals.list.chargementDonnees')">
        <ubi-panel :title="portal.nom" size="sm" v-if="portal != null">
            <template v-slot:left-column>
                <el-row>
                    <el-col :lg="20" :md="12">
                        <el-row>
                            <el-col :lg="20" class="mb-3">
                                <el-row>{{ $t("contacts.listDemandesRapprochementTotal") }} <strong>{{nbResults}}</strong></el-row>
                                <el-row>
                                    <el-col> <br></el-col>
                                </el-row>
                                <el-row>{{ $t("contacts.listAdsSent") }} <strong>{{nbAnnonces}}/{{totalAnnonces}}</strong></el-row>
                                <el-row>
                                    <el-col> <br></el-col>
                                </el-row>
                            </el-col>
                        </el-row>

                    </el-col>
                </el-row>
                <div class="Panel-footer">
                </div>
            </template>
            <template v-slot:right-column>
                <el-row v-loading.fullscreen.lock="loading"
                        :element-loading-text="$t('portals.list.chargementDonnees')">
                    <el-col :lg="20">
                        <div class="text-muted" style="text-align: center;">
                            <el-image
                                    :src="portal.logo"
                            />
                        </div>
                        <br>
                        <br>
                        <br>
                        <br>
                    </el-col>
                </el-row>
            </template>

        </ubi-panel>
        <el-form @submit.prevent.native="fetchList">
            <ubi-panel style="background-color: #EBF3F2;">
                <ubi-search-container
                        :filters="filters"
                        @filter="doFilter"
                        :defaultFilter="this.filter.preset"
                        v-on:resetfilter="doFilter('reset')">
                    <el-row :gutter="30">
                        <el-col :lg="12">
                            <el-form-item :label="$t('general.filters.referenceContactEmail')">
                                <el-input type="text" @input="setSearch" :value="filter.search" :placeholder="$t('general.filters.adReferencePlaceholder')" />
                            </el-form-item>
                        </el-col>
                        <el-col :lg="12">
                            <el-form-item :label="$t('general.filters.date')">
                                <el-date-picker
                                        type="daterange"
                                        :value="filter.beforeContacts || filter.afterContacts? [
                      filter.beforeContacts || undefined,
                      filter.afterContacts || undefined
                    ] : null"
                                        :start-placeholder="$t('general.filters.dateCreationStart')"
                                        :end-placeholder="$t('general.filters.dateCreationEnd')"
                                        @input="
                      dates => addFilter({ beforeContacts: dates? dates[0] : null, afterContacts: dates? dates[1] : null})
                    "
                                        format="dd/MM/yyyy"
                                        :picker-options="pickerOptions"
                                >
                                </el-date-picker>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </ubi-search-container>
            </ubi-panel>
        </el-form>

        <ubi-panel>
            <ubi-list-header slot="header"
                             :limits="limits"
                             :page.sync="page"
                             :limit.sync="limit"
                             :total="nbResults"
                             :sort.sync="sort"
                             :sortProperties="sortProperties">
            </ubi-list-header>
            <el-button type="mini" slot="actions" @click="exporter">
                <span @click="eventAnalytics('total_contact')">{{ $t("contacts.exportResults") }}</span>
            </el-button>
            <ubi-list-footer slot="footer" :limits="limits" :page.sync="page" :limit.sync="limit" :total="nbResults"></ubi-list-footer>
            <el-table ref="table" :data="contacts" v-loading.fullscreen.lock="loading"
                      :element-loading-text="$t('portals.list.chargementDonnees')">
                <el-table-column type="expand">
                    <template v-slot="{ row: result }">
                        {{result.commentaire}}
                    </template>
                </el-table-column>
                <el-table-column :label="$t('contacts.listColumnDateAndHour')" width="160">
                    <template v-slot="{ row: result }">
                        {{result.dateEnvoi}}
                    </template>
                </el-table-column>
                <el-table-column :label="$t('contacts.listColumnCivilityLastnameFirstname')" width="200">
                    <template v-slot="{ row: result }">
                        {{result.identite}}
                    </template>
                </el-table-column>
                <el-table-column :label="$t('contacts.listColumnEmail')" width="180">
                    <template v-slot="{ row: result }">
                        {{result.email}}
                    </template>
                </el-table-column>
                <el-table-column :label="$t('contacts.listColumnPhoneNumber')" width="180">
                    <template v-slot="{ row: result }">
                        {{result.telephone}}
                    </template>
                </el-table-column>
            </el-table>
        </ubi-panel>

        </div>
    </ubi-page-container>
</template>

<style lang="scss">
    @import "../../theme/_bootstrap.scss";
    .el-loading-spinner{
        top:10%!important;
    }
</style>

<script>
import moment from 'moment'
import { Collapse, CollapseItem, Divider, Tabs, TabPane } from 'element-ui'
import { mapState, mapMutations, mapGetters } from 'vuex'
import { getContactsPortailEnTete, getContactsPortail, getCalls, getNbCalls, exportContacts, exportCalls } from '../../services/contacts'
import PieChart from '../../services/piechart'
import { getDiffuseurInfos } from '../../services/portals'
export default {
  name: 'DetailContactsPerPortal',
  inject: ['browserContext'],
  components: {
    PieChart,
    ElCollapse: Collapse,
    ElCollapseItem: CollapseItem,
    ElDivider: Divider,
    ElTabs: Tabs,
    ElTabPane: TabPane
  },
  data () {
    return {
      loading: false,
      offset: 0,
      portalId: this.$route.params.portal,
      portal: null,
      limits: [10, 10 * 2, 10 * 5, 10 * 10],
      enTete: null,
      nbResults: 0,
      nbResultsCalls: 0,
      nbCalls: 0,
      graphDataTypesBiens: null,
      graphDataTypesOffres: null,
      calls: null,
      sortProperties: {
        date: this.$t('general.sort.date'),
        reference: this.$t('general.sort.reference'),
        identite: this.$t('general.sort.contactName')
      },
      sortPropertiesCalls: {
        '-dateStarted': this.$t('general.sort.date'),
        '-callDuration': this.$t('general.sort.callDurationDecrease'),
        callDuration: this.$t('general.sort.callDurationIncrease'),
        callerNumber: this.$t('general.sort.callNumber')
      },
      nbContactsGeneres: 0,
      nbContactsGeneresTotal: 0,
      nbProspects: 0,
      nbAnnonces: 0,
      contacts: null,
      nbPortailsActifs: 0,
      totalAnnonces: 0,
      graphData: {},
      activeName: 'Mailtracking',
      filters: [
        { value: 'reset', label: this.$t('general.filters.allContacts') }
      ]
    }
  },
  computed: {
    ...mapState('contactsListRapprochementPortals', ['filter', 'results']),
    ...mapGetters(['getPickerOptionsShortcuts']),
    sitimmoUser () {
      return this.$store.getters.getSitimmoUser
    },
    possedeCallTracking () {
      return this.sitimmoUser.possede_call_tracking
    },
    pickerOptions () {
      return {
        shortcuts: this.getPickerOptionsShortcuts
      }
    },
    page: {
      get () {
        return this.filter.page
      },
      set (value) {
        this.setOffset((value - 1) * this.limit)
        this.setPage(value)
        this.fetchList()
        return this.setPage(value)
      }
    },
    limit: {
      get () {
        return this.filter.limit
      },
      set (value) {
        this.setLimit(value)
        this.setOffset(0)
        this.setPage(1)
        this.fetchList()
        return this.setLimit(value)
      }
    },
    sort: {
      get () {
        return this.filter.sort
      },
      set (value) {
        this.setSort(value)
        this.setOffset(0)
        this.setPage(1)
        this.fetchList()
        return this.setSort(value)
      }
    },
    pageCalls: {
      get () {
        return this.filter.pageCalls
      },
      set (value) {
        this.setOffsetCalls((value - 1) * this.limit)
        this.setPageCalls(value)
        this.fetchList()
        return this.setPageCalls(value)
      }
    },
    sortCalls: {
      get () {
        return this.filter.sortCalls
      },
      set (value) {
        this.setSortCalls(value)
        this.setOffsetCalls(0)
        this.setPageCalls(1)
        this.fetchList()
        return this.setSortCalls(value)
      }
    }
  },
  beforeMount () {
    this.filter.beforeContacts = this.$store.getters['donnees/getContactsDateBefore']
    this.filter.afterContacts = this.$store.getters['donnees/getContactsDateAfter']
    // this.setSort('date');
    // this.setSearch('');
    this.fetchPortal()
    // this.fetchList();//this is done inside searchfilter
  },
  methods: {
    eventAnalytics (category) {
      this.$ga.event('contact_manager_portails', 'clic', category, this.sitimmoUser.id)
    },
    async getEnTete () {

    },
    async exportCalls () {
      const res = await exportCalls(this.filter, this.portal, this.$t('contacts.filenameExportContactsPerPortal'))
      this.$message(res)
      this.loading = false
    },
    convertDate: function (date) {
      return 'Le ' + moment(date).format('DD/MM/YYYY à hh:mm:ss')
    },
    ...mapMutations('contactsListRapprochementPortals', [
      'setPage',
      'setPageCalls',
      'setLimit',
      'setSort',
      'setSortCalls',
      'setSearch',
      'setCategory',
      'setGratuit',
      'setFilter',
      'addFilter',
      'setResults',
      'setOffset',
      'setOffsetCalls',
      'resetFilter',
      'setStatutAppel',
      'setSearchCalls',
      'setRapprochement'
    ]),
    handleClose (done) {
      this.$confirm(this.$t('general.exitConfirmation'))
        .then(_ => {
          done()
        })
        .catch(_ => {})
    },
    doFilter (type) {
      switch (type) {
        case 'reset':
          this.resetFilter()
          break
        case 'gratuits':
          this.filter.gratuit = true
          this.setFilter(this.filter)
          break
      }
      this.fetchList()
    },
    async fetchPortal () {
      const portalInfos = await (getDiffuseurInfos(this.portalId))
      if (portalInfos.type == 'error') {
        this.$message({ message: this.$t('error.found'), type: 'error' })
        this.loading = false
        return false
      }
      this.portal = portalInfos.reponse
    },
    async fetchList () {
      this.$store.commit('donnees/SET_CONTACTS_DATE_BEFORE', this.filter.beforeContacts)
      this.$store.commit('donnees/SET_CONTACTS_DATE_AFTER', this.filter.afterContacts)
      // No need to interrupt promises when the router changes...
      this.loading = true
      await (this.getEnTete())

      this.filter.rapprochement = 'O'
      const temp = await getContactsPortail(this.filter, this.portalId)

      if (temp.type == 'error') {
        this.$message({ message: this.$t('error.found'), type: 'error' })
        this.loading = false
        return false
      }
      this.setResults(temp)
      this.nbCalls = await getNbCalls(this.filter, this.portal)
      if (this.nbCalls.type == 'error') {
        this.$message({ message: this.$t('error.found'), type: 'error' })
        this.loading = false
        return false
      }
      this.calls = await getCalls(this.filter, this.portal)
      if (this.calls.type == 'error') {
        this.$message({ message: this.$t('error.found'), type: 'error' })
        this.loading = false
        return false
      }

      this.nbResults = this.results.infos.total_items
      if(this.nbResults > 0) {
        this.contacts = this.results.infos.contact_mailtracking
      }

      this.loading = false
    },
    convertDuration (seconds) {
      const duration = moment('1900-01-01 00:00:00').add(seconds, 'seconds').format('mm:ss')
      return duration
    },
    async exporter () {
      this.filter.rapprochement = 'O'
      const res = await exportContacts(this.filter, null, null, this.portalId, this.$t('contacts.filenameExportContactsPerPortal'))
      this.$message(res)
      this.loading = false
    }
  }

}
</script>
<style>
    .el-tab-pane {
        background-color: aliceblue;
    }
    .el-tabs__item.is-active {
        background-color: white;
        color: #0ab1bf;
    }

    .el-tabs__item .is-active .is-top {
        background-color: white;
        color: #0ab1bf;
    }
    .el-tabs__item .is-top {
        background-color: white;
        color: #0ab1bf;
    }

    .el-tabs__item:hover {
        color: #0ab1bf;
    }

    .el-tabs__item {
        color: #184a56;
        height: auto;
        font-size: 1rem;
        line-height: 1rem;
    }

</style>
